import {SectionDto} from '@domain/pom'
import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useEffect} from 'react'
import {useNavigate} from 'react-router'

import {TasksApiPath} from '../../consts'
import {handleTasksError as handleError} from '../../utils'

const PomQuestionnairesSectionsQueryKey = 'pom-questionnaires-sections'

export const usePomSections = <TSelect = SectionDto[]>(
  options?: Omit<UseQueryOptions<SectionDto[], AxiosError, TSelect>, 'queryKey' | 'queryFn'>
) => {
  const navigate = useNavigate()
  const path = `${TasksApiPath.POM_QUESTIONNARIES}/sections`

  const query = useQuery<SectionDto[], AxiosError, TSelect>({
    queryKey: [PomQuestionnairesSectionsQueryKey],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<SectionDto[]>(path, {signal})

      return response.data ?? []
    },
    ...options
  })

  useEffect(() => {
    if (query.error) {
      handleError(query.error, navigate)
    }
  }, [query.error, navigate])

  return query
}
